"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
class BifrostNumber {
    constructor(value) {
        this._isBifrostNumber = true;
        if (value instanceof bignumber_js_1.default) {
            this.value = value;
        }
        else {
            this.value = this.parseValue(value);
        }
    }
    static [Symbol.hasInstance](obj) {
        return obj._isBifrostNumber && obj.value instanceof bignumber_js_1.default;
    }
    parseValue(value) {
        let result;
        switch (typeof value) {
            case 'object':
                if (value instanceof Buffer) {
                    result = new bignumber_js_1.default(value.toString());
                }
                else if (value instanceof BifrostNumber) {
                    result = value.value;
                }
                else if (value instanceof bignumber_js_1.default) {
                    result = value;
                }
                else {
                    console.log('bifrost-number.parseValue', 'wrong data object', value);
                    throw new Error(`bifrost-number.parseValue.wrong_data_object: ${value}`);
                }
                break;
            case 'string':
            case 'number':
                result = new bignumber_js_1.default(value);
                break;
            case 'undefined':
                result = new bignumber_js_1.default('0');
                break;
            default:
                console.log('bifrost-number.parseValue', 'wrong data', typeof value, value);
                throw new Error(`bifrost-number.parseValue.wrong_data: ${typeof value} ${value}`);
                break;
        }
        return result;
    }
    plus(value) {
        return new BifrostNumber(this.value.plus(this.parseValue(value)));
    }
    minus(value) {
        return new BifrostNumber(this.value.minus(this.parseValue(value)));
    }
    mul(value) {
        return new BifrostNumber(this.value.multipliedBy(this.parseValue(value)));
    }
    times(value) {
        return new BifrostNumber(this.value.times(this.parseValue(value)));
    }
    div(value) {
        return new BifrostNumber(this.value.div(this.parseValue(value)));
    }
    idiv(value) {
        return new BifrostNumber(this.value.idiv(this.parseValue(value)));
    }
    pow(value) {
        return new BifrostNumber(this.value.pow(this.parseValue(value)));
    }
    mod(value) {
        return new BifrostNumber(this.value.mod(this.parseValue(value)));
    }
    dp(value) {
        return new BifrostNumber(this.value.dp(this.parseValue(value).toNumber()));
    }
    abs() {
        return new BifrostNumber(this.value.abs());
    }
    negate() {
        return new BifrostNumber(this.value.negated());
    }
    eq(value) {
        return this.value.eq(this.parseValue(value));
    }
    gt(value) {
        return this.value.gt(this.parseValue(value));
    }
    gte(value) {
        return this.value.gte(this.parseValue(value));
    }
    lt(value) {
        return this.value.lt(this.parseValue(value));
    }
    lte(value) {
        return this.value.lte(this.parseValue(value));
    }
    cp(value) {
        return this.value.comparedTo(this.parseValue(value));
    }
    isZero() {
        return this.value.isZero();
    }
    isInt() {
        return this.value.isInteger();
    }
    isNaN() {
        return this.value.isNaN();
    }
    isPositive() {
        return this.value.isPositive();
    }
    isNegative() {
        return this.value.isNegative();
    }
    toString() {
        return this.toStr();
    }
    toStr(isInteger = false) {
        let result = this.value.toFixed(1000);
        const dotIndex = result.indexOf('.');
        if (dotIndex > 0 && dotIndex < result.length) {
            if (isInteger) {
                result = result.slice(0, dotIndex);
            }
            else {
                result = result.replace(/0*$/, '');
                if (dotIndex + 1 === result.length) {
                    result = result.slice(0, dotIndex);
                }
                if (result.length === 0) {
                    result = '0';
                }
            }
        }
        else if (dotIndex === 0) {
            result = '0';
        }
        if (result === '-0') {
            result = '0';
        }
        return result;
    }
    toNum(isInteger = false) {
        let result = 0;
        if (isInteger) {
            result = new bignumber_js_1.default(this.toStr(true)).toNumber();
        }
        else {
            result = this.value.toNumber();
        }
        return result;
    }
    toHex(isInteger = false) {
        let result = '0x0';
        if (isInteger) {
            result = `0x${new bignumber_js_1.default(this.toStr(true)).toString(16)}`;
        }
        else {
            result = `0x${this.value.toString(16)}`;
        }
        return result;
    }
    balanceFormat(replaceString = '{}', decimalLimit = 20, lengthLimit = 20, showDecimalZero = false, comma = true) {
        let result = this.toStr();
        const dotIndex = result.indexOf('.');
        if (typeof decimalLimit === 'number' && decimalLimit > 0) {
            if (dotIndex > 0 && dotIndex < result.length) {
                result = result.slice(0, dotIndex + 1 + decimalLimit);
                if (typeof lengthLimit === 'number' && lengthLimit > -1 && result.length > lengthLimit) {
                    result = result.slice(0, dotIndex <= lengthLimit ? lengthLimit : dotIndex);
                }
            }
            else if (dotIndex === 0) {
                result = '0';
            }
        }
        else {
            result = this.toStr(true);
        }
        if (showDecimalZero) {
            if (decimalLimit && decimalLimit > 0) {
                let addZeroLength = 0;
                if (dotIndex < 0 || dotIndex >= result.length) {
                    result = `${result}.`;
                    addZeroLength = decimalLimit;
                }
                else if (result.length - dotIndex < 3) {
                    addZeroLength = 3 - (result.length - dotIndex);
                }
                if (addZeroLength > 0) {
                    for (; 0 < addZeroLength; addZeroLength--) {
                        result += '0';
                    }
                }
            }
        }
        else {
            if (dotIndex > 0 && dotIndex < result.length) {
                result = result.replace(/0*$/, '');
                if (dotIndex + 1 === result.length) {
                    result = result.slice(0, dotIndex);
                }
                if (result.length === 0) {
                    result = '0';
                }
            }
            else if (dotIndex === 0) {
                result = '0';
            }
        }
        if (comma) {
            if (dotIndex > 0 && dotIndex < result.length) {
                result = `${result.slice(0, dotIndex).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${result.slice(dotIndex)}`;
            }
            else {
                result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        }
        if (result === '-0') {
            result = '0';
        }
        result = replaceString.replace('{}', result);
        return result;
    }
}
exports.default = BifrostNumber;
;
//# sourceMappingURL=index.js.map